import { z } from 'zod';
export const RentalItemSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1),
    category: z.string(),
    dailyRate: z.number().positive(),
    currency: z.enum(['NOK', 'EUR', 'USD', 'GBP']),
    available: z.boolean(),
    availableFrom: z.string().datetime().optional(),
    availableTo: z.string().datetime().optional(),
    merchantId: z.string().uuid(),
});
export const CustomerSchema = z.object({
    id: z.string().uuid().optional(),
    email: z.string().email(),
    name: z.string().min(1),
    phone: z.string().optional(),
    locale: z.string().default('en'),
});
export const BookingRequestSchema = z.object({
    customerId: z.string().uuid().optional(),
    customerEmail: z.string().email(),
    itemIds: z.array(z.string().uuid()).min(1),
    startDate: z.string().datetime(),
    endDate: z.string().datetime(),
    notes: z.string().optional(),
    merchantId: z.string().uuid(),
});
export const LockedContractSchema = z.object({
    id: z.string().uuid(),
    status: z.enum(['draft', 'pending_signature', 'signed', 'cancelled', 'expired']),
    booking: BookingRequestSchema,
    items: z.array(RentalItemSchema),
    customer: CustomerSchema,
    totalAmount: z.number().positive(),
    currency: z.enum(['NOK', 'EUR', 'USD', 'GBP']),
    createdAt: z.string().datetime(),
    expiresAt: z.string().datetime(),
    signatureUrl: z.string().url().optional(),
    merchantName: z.string(),
});
//# sourceMappingURL=contract.js.map